import {
    VContainer,
    VRow,
    VCol,
    VTextField,
    VBtn,
    VBtnToggle, VSelect,
} from "vuetify/lib";
import {mapGetters} from "vuex";
import {
    applyStatus
} from "./constants.js";

export default {
    props: {
        value: {
            type: Object,
            default: () => ({
                search: "",
                search_type: "pending",
                apply_team_id: "",
                batch_uid: "",
                status: "",
            }),
        },
    },
    data() {
        this.$set(this.value, "search", "");
        this.$set(this.value, "search_type", "pending");
        return {};
    },
    computed: {
        ...mapGetters({
            companies: "async/companies",
            companies_hash: "async/companies_hash",
            teams: "async/root_teams",
            teams_hash: "async/root_teams_hash",
        }),
        showStatusSelect() {
            return this.value.search_type !== "import_info";
        },
        // 在 computed 中添加
        showExportButton() {
            // 检查当前用户是否属于财务组
            const curCustomer = this.$store.state.cur_customer;
            const isFinancer = curCustomer && curCustomer.groups && curCustomer.groups.includes('GROUP_FIN');
            return this.value.search_type !== "import_info" && isFinancer;
        }
    },
    watch: {},
    mounted() {
        this.onSearch();
    },
    methods: {
        onSearch() {
            this.$emit("search");
        },
    },
    render() {
        return (
            <div>
                <VContainer fluid>
                    <VRow align="center">
                        <VCol cols="2">
                            <VSelect
                                items={this.teams}
                                label="项目组"
                                item-text="name"
                                item-value="id"
                                v-model={this.value.apply_team_id}
                                clearable
                                on={{
                                    change: () => {
                                        this.onSearch();
                                    }
                                }}
                            ></VSelect>
                        </VCol>
                        {this.showStatusSelect && (
                            <VCol cols="2">
                                <VSelect
                                    items={applyStatus}
                                    label="申请状态"
                                    item-text="label"
                                    item-value="value"
                                    v-model={this.value.status}
                                    clearable
                                    on={{
                                        change: () => {
                                            this.onSearch();
                                        }
                                    }}
                                ></VSelect>
                            </VCol>
                        )}
                        <VCol cols="2">
                            <VTextField label="批次号" v-model={this.value.batch_uid}/>
                        </VCol>
                        <VCol cols="3" style="display: flex; align-items: center; flex-wrap: nowrap;">
                            <VTextField label="搜索关键词" v-model={this.value.search} style="flex: 1; margin-right: 10px;"/>
                            <VBtn
                                color="primary"
                                elevation="2"
                                onClick={() => {
                                    this.onSearch();
                                }}
                                style="flex-shrink: 0;"
                            >
                                搜索
                            </VBtn>
                        </VCol>
                    </VRow>
                    <VRow align="center" style="margin-top:-35px;">
                        <VCol cols="9" style="display: flex; justify-content: center; align-items: center; flex-direction: column;">
                            <div style="margin: 0;">
                                <a
                                    href="https://shimo.im/docs/RKAWMMWEdeUxKeq8/"
                                    target="_blank"
                                    style="margin: 0 10px; color: #1976d2; text-decoration: none;"
                                    onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
                                    onMouseOut={(e) => e.target.style.textDecoration = 'none'}
                                >
                                    线下退款流程规范V2.0
                                </a>
                                <a
                                    href="https://shimo.im/docs/XKq422MQm0TLwZAN/"
                                    target="_blank"
                                    style="margin: 0 10px; color: #1976d2; text-decoration: none;"
                                    onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
                                    onMouseOut={(e) => e.target.style.textDecoration = 'none'}
                                >
                                    线下退款系统操作指南V1.0
                                </a>
                                <a
                                    href="https://shimo.im/sheets/XKq422Z7YRFWQ5AN/MODOC/"
                                    target="_blank"
                                    style="margin: 0 10px; color: #f44336; text-decoration: none;"
                                    onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
                                    onMouseOut={(e) => e.target.style.textDecoration = 'none'}
                                >
                                    佣金返现&退运费登记表
                                </a>
                            </div>
                        </VCol>
                    </VRow>
                    <VRow align="center">
                        <VCol>
                            <VBtnToggle
                                v-model={this.value.search_type}
                                small
                                mandatory
                                on={{
                                    change: () => {
                                        this.onSearch();
                                    },
                                }}
                            >

                                <VBtn height="32" value="pending">
                                    待我处理
                                </VBtn>

                                <VBtn height="32" value="related">
                                    与我相关
                                </VBtn>

                                <VBtn height="32" value="mine">
                                    我发起的
                                </VBtn>
                                <VBtn height="32" value="all">
                                    所有申请
                                </VBtn>
                                <VBtn height="32" value="import_info">
                                    导入批次
                                </VBtn>
                            </VBtnToggle>
                        </VCol>
                        <VCol>
                            <VBtn
                                color="primary"
                                elevation="2"
                                style="margin-left: 20px;"
                                onClick={() => {
                                    this.$emit("add");
                                }}
                            >
                                创建退款申请
                            </VBtn>
                            <VBtn
                                color="primary"
                                elevation="2"
                                style="margin-left: 20px;"
                                onClick={() => {
                                    this.$emit("import");
                                }}
                            >
                                批量导入申请
                            </VBtn>
                            <VBtn
                                color="primary"
                                elevation="2"
                                style="margin-left: 20px;"
                                onClick={() => {
                                    this.$emit("export");
                                }}
                                v-show = {this.showExportButton}
                            >
                                导出
                            </VBtn>
                            <VBtn
                                type="warning"
                                elevation="2"
                                style="margin-left: 20px;"
                                onClick={() => {
                                    this.$emit("downloadTemplate");
                                }}
                            >
                                下载导入模板
                            </VBtn>
                        </VCol>
                    </VRow>
                </VContainer>
            </div>
        );
    },
};